import { Col, Form, Row, Select } from "antd";
import type React from "react";

interface MemberMembershipStatusFilterProps {
	className?: string;
}

export const MemberMembershipStatusFilter: React.FC<
	MemberMembershipStatusFilterProps
> = ({ className = "mb-4" }) => {
	return (
		<Row gutter={[16, 16]} justify="start">
			<Col xs={{ span: 24 }}>
				<Form.Item name="membershipStatus" className={className}>
					<Select
						placeholder="ステータスを選択"
						allowClear
						options={[
							{ value: "provisional", label: "仮登録" },
							{ value: "active", label: "本登録" },
							{ value: "expired", label: "期限切れ" },
							{ value: "deactivated", label: "無効" },
						]}
					/>
				</Form.Item>
			</Col>
		</Row>
	);
};
